module.exports = __webpack_public_path__ + "static/media/经济政策.e109e432.svg";